// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { changeCustomerFulfillmentMethodStyles } from "@rpsc/Overrides/Widgets/ChangeCustomer/ChangeCustomerFulfillmentMethodSelector";
import SavedAddresses from "@rpsc/XDL/Icons/SavedAddresses";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { createLinkIconStyles } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

changeCustomerFulfillmentMethodStyles.pickupLocationGridItem = {
    width: 12,
    css: css`
        margin-top: 20px;

        &:empty {
            display: none;
        }
    `,
};

changeCustomerFulfillmentMethodStyles.container = {
    gap: 0,
};

changeCustomerFulfillmentMethodStyles.pickUpLocation = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    headerText: {
        variant: "h6",
        css: css`
            margin: 0;
        `,
    },
    titleWrapper: {
        css: css`
            display: flex;
            gap: 24px;
            align-items: center;
            margin-bottom: 4px;
        `,
    },
    changeLink: {
        ...createLinkIconStyles(SavedAddresses, {
            typographyProps: {
                size: 12,
                lineHeight: "14px",
                weight: fontConfig.weight.bold,
            },
        }),
    },
    warehouseAddress: { nameText: { size: 14, lineHeight: "22px" } },
};
